export const createDeleteForm = id => "importationDelete" + id;